"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickAway = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("./utils");

var defaultEvents = ['mousedown', 'touchstart'];

function useClickAway(ref, onClickAway, events) {
  if (events === void 0) {
    events = defaultEvents;
  }

  var savedCallback = React.useRef(onClickAway);
  React.useEffect(function () {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var handler_1 = function handler_1(event) {
        var el = ref.current;

        if (!!el && event.target !== null && !el.contains(event.target)) {
          savedCallback.current(event);
        }
      };

      for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var eventName = events_1[_i];
        utils_2.on(document, eventName, handler_1);
      }

      return function cleanup() {
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
          var eventName = events_2[_i];
          utils_2.off(document, eventName, handler_1);
        }
      };
    }
  }, [events, ref]);
}

exports.useClickAway = useClickAway;